import React, { useState } from "react";
import Header from "components/Header/HeaderTribalism.js";
import Footer from "components/Footer/TribalismFooter.js";
import Section8Contacts from "pages-sections/home-page/Section8Contacts.js";
import HeaderLinks from "components/Header/HeaderLinksTribalism.js";
import tedaiStyles from "./TedaiCommon.module.scss";

const videos = [
  {
    src: "/img/tedai2024/videos/waymo_vid4.mp4",
    title: "Waymo Autonomous Vehicle - Day Time",
    description: "Riding in a Waymo autonomous vehicle in San Francisco, avoiding 3 edge case/potential accidents in 30 seconds"
  },
  {
    src: "/img/tedai2024/videos/waymo2.mp4",
    title: "Waymo Autonomous Vehicle  - Day Time",
    description: "See how easy it is to get going in a Waymo autonomous vehicle, night time is no problem."
  },
  {
    src: "/img/tedai2024/videos/robots.mp4",
    title: "Robots at the Transamerica Pyramid",
    description: "Day 1 afterparty of TEDAI 2024"
  },
  {
    src: "/img/tedai2024/videos/afterparty.mp4",
    title: "Afterparty at Shack15 - San Francisco",
    description: "Great conversations with various attendees at the Shack15 in the Ferry Building, San Francisco"
  },
  // Add more videos here as needed
];

export default function TEDAI2024FunSection() {
  const classes = tedaiStyles;

  return (
    <div>
      <Header
        brand="/img/clients/TribalismLogoRev.webp"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color="transparent"
        title="TEDAI2024 - Fun Section"
        image="/img/tedai2024/home/gallery-header-min.jpeg"
        url="https://www.tribalism.com.au/tedai2024"
        type="article"
        description="TEDAI2024 Fun Section"
        changeColorOnScroll={{
          height: 400,
          color: "info",
        }}
      />

      {/* Hero Section */}
      <div className={classes.heroSection1}>
        <img
          src="/img/tedai2024/home/gallery-header-min.jpeg"
          alt="TEDAI2024"
          className={classes.heroImage}
        />
      </div>
      
      <div className={classes.heroSection}>
        <h1 className={classes.mainTitle}>TEDAI 2024 Fun Moments</h1>
        <p className={classes.introText}>
          During our time at TEDAI 2024 in San Francisco, we captured some exciting moments including our autonomous vehicle rides and other interesting experiences. Here are some video highlights from our journey!
        </p>
      </div>

      <div className={classes.container}>
        <div className={classes.videoGrid}>
          {videos.map((video, index) => (
            <div key={index}>
              <div className={classes.videoContainer}>
                <video
                  className={classes.video}
                  controls
                  playsInline
                  preload="metadata"
                >
                  <source src={video.src} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
              <h3>{video.title}</h3>
              <p>{video.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Contact and Footer Sections */}
      <Section8Contacts />
      <Footer />
    </div>
  );
}